import { useState } from "react";
import { toast } from "sonner";
import { Boxes } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function InventoryCard() {
  const { session } = useAuth();
  const [on, setOn] = useState(!!session.business.inventory_on);
  const [busy, setBusy] = useState(false);
  const flip = async (v) => {
    setBusy(true);
    try {
      await api.put("/settings/inventory", { on: v });
      setOn(v);
      toast.success(v ? "Inventory switched on — existing stock is under UNASSIGNED" : "Inventory switched off — your data is kept");
      window.dispatchEvent(new Event("session-stale"));
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-6 flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5" data-testid="settings-inventory-card">
      <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-slate-950 text-amber-400"><Boxes className="h-5 w-5" /></div>
      <div className="flex-1">
        <div className="font-semibold text-slate-900">Inventory (Goods Receiving & shelves)</div>
        <p className="mt-0.5 text-sm text-slate-500">Receive goods with GRNs, put them away to shelf locations and see where to pick on every cart line.</p>
      </div>
      <Switch checked={on} disabled={busy} onCheckedChange={flip} data-testid="settings-inventory-switch" aria-label="Inventory add-on" />
    </div>
  );
}
